import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, Flex, Box } from "sprout-ui-primitives";
import { Link } from "react-router-dom";
import TimeAgo, { time } from "@sprout/client-components/dist/TimeAgo";
import PostPageCommentMenu from "./PostPageCommentMenu";
const PostPageCommentMeta = (props)=>{
    const { comment , parentCommentId  } = props;
    const { id , createdAt , editedAt  } = comment;
    const { owner  } = comment;
    if (!owner) return null;
    const { username  } = owner;
    return /*#__PURE__*/ _jsxs(Flex, {
        alignItems: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                truncate: true,
                mr: 1,
                as: Link,
                to: `/${username}`,
                fontWeight: "bold",
                children: username
            }),
            /*#__PURE__*/ _jsxs(Text, {
                truncate: true,
                as: Link,
                to: `#comment-${id}${parentCommentId ? `-${parentCommentId}` : ""}`,
                color: "black.60",
                fontSize: "15px",
                children: [
                    /*#__PURE__*/ _jsx(TimeAgo, {
                        date: createdAt
                    }),
                    editedAt !== null && /*#__PURE__*/ _jsx("span", {
                        title: time.render(new Date(editedAt)),
                        children: ` (edited)`
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                ml: "auto",
                pl: 0,
                children: /*#__PURE__*/ _jsx(PostPageCommentMenu, {
                    comment: comment,
                    parentCommentId: parentCommentId
                })
            })
        ]
    });
};
export default PostPageCommentMeta;
